import { apiClient } from '@/core/api/client';

/** Lightweight partner-company option used in the Screen 2 company dropdown. */
export type PartnerCompanyOption = {
  id: string;
  name: string;
  logoUrl: string | null;
};

/** Lightweight FA option used in the Screen 2 dependent advisor dropdown. */
export type AdvisorOption = {
  id: string;
  firstName: string;
  lastName: string | null;
};

/** Body of PATCH /auth/care-seeker/me/fp-association. */
export type FpAssociationPayload = {
  partnerCompanyId?: string;
  advisorId?: string;
  unmatchedAdvisorName?: string;
};

/**
 * Prefix search of active partner companies (feature 076-02). The backend
 * requires q to be at least 2 characters after trimming and returns only
 * case-insensitive starts-with matches — the full firm list is not served.
 */
export const listPartnerCompaniesPublic = async (
  q: string,
): Promise<PartnerCompanyOption[]> => {
  const response = await apiClient.get<PartnerCompanyOption[]>(
    '/partner-companies/list/public',
    { params: { q } },
  );
  return response.data;
};

export const listAdvisorsForCompanyPublic = async (
  companyId: string,
): Promise<AdvisorOption[]> => {
  const response = await apiClient.get<AdvisorOption[]>(
    `/partner-companies/${encodeURIComponent(companyId)}/advisors/public`,
  );
  return response.data;
};

/** Called post-Kinde (authenticated) to apply Screen 2 answers. */
export const updateFpAssociation = async (
  payload: FpAssociationPayload,
): Promise<{ ok: true }> => {
  const response = await apiClient.patch<{ ok: true }>(
    '/auth/care-seeker/me/fp-association',
    payload,
  );
  return response.data;
};
